import { DateTime } from 'luxon';
import { PlatformAvailability } from '../enums/platform-availability.enum';

/**
 * Converts a profile availability option into an approximate start date (unix seconds).
 * @param availability - Relative availability from the profile
 * @returns Unix timestamp in seconds, or null when unavailable
 */
export function startDateFromAvailability(
  availability: PlatformAvailability | string | null | undefined
): number | null {
  if (!availability) {
    return null;
  }
  const now = DateTime.now().startOf('day');
  let date: DateTime | null = null;
  switch (availability) {
    case PlatformAvailability.IMMEDIATE:
      date = now;
      break;
    case PlatformAvailability.IN_1_MONTH:
      date = now.plus({ months: 1 });
      break;
    case PlatformAvailability.IN_2_MONTHS:
      date = now.plus({ months: 2 });
      break;
    case PlatformAvailability.IN_3_MONTHS:
      date = now.plus({ months: 3 });
      break;
    case PlatformAvailability.MORE_THAN_3_MONTHS:
      date = now.plus({ months: 4 });
      break;
    default:
      return null;
  }
  return date.toUnixInteger();
}

/**
 * Parses an ISO calendar day into unix seconds.
 * @param value - ISO date string (YYYY-MM-DD)
 * @returns Unix timestamp in seconds, or null when invalid
 */
export function startDateFromIso(value: string | null | undefined): number | null {
  if (!value) {
    return null;
  }
  const date = DateTime.fromISO(value);
  return date.isValid ? date.toUnixInteger() : null;
}
